import React, { useMemo } from "react";
import { Col } from "react-bootstrap";
import { useFormatter } from "../../util/formatter";
import { useSaving } from "../../util/calculations";
import moment from "moment-timezone";

const MainSavings = (props) => {
	const calculateFormula = props.calculateFormula;
	const selectedSite = props.selectedSite;
	const senSavData = props.senSavData;
	const currency = props.currency;
	
	// saving
	const savingData = useSaving({ table_names: selectedSite?.table_name, date: moment(), month: moment()});
	const savingFmt = savingData.length > 0 ? savingData[0].saving.toLocaleString('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 }) : 0;

	const [formatNumber] = useFormatter();

	return (
		<>
			<Col md="12">
				<h5 style={{ textAlign: "center" }}>Savings</h5>
			</Col>
			<Col
				md="4"
				style={{ textAlign: "center", borderRight: "1px solid #666" }}
			>
				<h6>
					CO<sub>2</sub> Avoided
				</h6>
				<p>
					{selectedSite != null
						? formatNumber(
								calculateFormula("CO2_TREES", selectedSite, senSavData)[0]
						  )
						: ""}{" "}
					kg
				</p>
			</Col>
			<Col
				md="4"
				style={{ textAlign: "center", borderRight: "1px solid #666" }}
			>
				<h6>Trees Planted</h6>
				<p>
					{selectedSite != null
						? formatNumber(
								calculateFormula("CO2_TREES", selectedSite, senSavData)[1]
						  )
						: ""}
				</p>
			</Col>
			<Col md="4" style={{ textAlign: "center" }}>
				<h6>Money saved</h6>
				<p>
					{savingFmt} {currency}
				</p>
			</Col>
		</>
	);
};

export default MainSavings;
